import { LyftDispatchRideFareAdjustmentReason } from './lyft-dispatch-ride-fare-adjustment-reason';
import { autoserializeAs, autoserialize } from 'cerialize';

export class LyftDispatchRideFareAdjustmentRequest {
  @autoserialize
  lyftDispatchRideId: number;

  @autoserializeAs(LyftDispatchRideFareAdjustmentReason)
  lyftDispatchRideFareAdjustmentReason: LyftDispatchRideFareAdjustmentReason;

  @autoserialize
  requestDescription: string;

  @autoserialize
  createdByUserId: number;
}
